import { useEffect, useState } from "react";
import CNLogo from "../../../components/CNLogo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleLeft,
  faCertificate,
  faTrophy,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  CircularProgressbar,
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import {
  getCertificate,
  unlockCertificate,
  getCertificateLink,
} from "../../../redux/actions/certificate";
import { userActivity } from "../../../common/constants";
import Gamification from "../../../components/Gamification";
import { useGamification } from "../../../context/GamificationContext";
import { getChallengeInfo } from "../../../redux/actions/quiz";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
import {
  downloadCertificate,
  generateCertificate,
} from "../../../utils/generateCertificate";
import certificate from "./assets/certificate.png";
import { IKImage } from "imagekitio-react";
import CertificatePreview from "./CertificatePreview";
import ExitPopUp from "./ExitPopUp";

export default function ContentPlayerNavbar({
  playerDetails,
  progress,
  mskill_slug,
  quizRef,
  mskillProgressObject,
  skillProgress,
}) {
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const user_token = useSelector((store) => store?.authentication?.user_token);
  const email = useSelector((store) => store?.profileDetails?.email);
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const dispatch = useDispatch();
  const { setOpenConfirmationModal, setType } = useGamification();
  const navigate = useNavigate();
  const { contentId } = useParams();
  const [challengeInfo, setChallengeInfo] = useState(null);
  const user_coin = useSelector(
    (store) => store?.userActivity?.user_coins?.["available-coins"],
  );
  const is_activation = useSelector(
    (store) => store?.userActivity?.is_activation,
  );
  const [isPreview, setIsPreview] = useState(false);
  const [isExitPopUp, setIsExitPopUp] = useState(false);

  useEffect(() => {
    if (progress === 100) {
      dispatch(
        getChallengeInfo(user_id, mskill_slug, (successObj) => {
          setChallengeInfo(successObj[0]);
        }),
      );
      dispatch(getCertificate(user_id, mskill_slug));
    }

    return () => {
      setChallengeInfo(null);
    };
  }, [progress, contentId]);

  function certificateDownloadHandler() {
    if (user_token) {
      dispatch(
        getCertificate(user_id, mskill_slug, async (data) => {
          if (data?.certificate_unlock_status === "locked") {
            await dispatch(unlockCertificate(user_id, mskill_slug));
            // Trigger Img download
            dispatch(
              getCertificateLink(data.unique_certificate_id, (link) => {
                downloadCertificate(link);
              }),
            );
          } else {
            // Trigger Img download
            dispatch(
              getCertificateLink(data.unique_certificate_id, (link) => {
                downloadCertificate(link);
              }),
            );
          }
        }),
      );
    } else navigate("/login");
  }

  return (
    <>
      <div
        className="flex items-center justify-between bg-white py-1 px-2 shadow-lg md:px-8"
        onMouseMove={(e) => {
          if (e.clientX <= window.innerWidth * 0.9 && e.clientY <= 30) {
            setIsExitPopUp(true);
          } else {
            setIsExitPopUp(false);
          }
        }}
      >
        {
          <Link
            to={`/${playerDetails?.["course_slug"]}/${playerDetails?.["skill_slug"]}`}
            style={{ pointerEvents: is_activation ? "none" : "auto" }}
          >
            {!is_activation ? (
              <div className="top-3 left-3 flex cursor-pointer items-center justify-between rounded border-2 border-slate-800 bg-white py-2 px-2 text-xs font-bold hover:bg-zinc-50 hover:text-black md:left-10 md:text-sm">
                <FontAwesomeIcon
                  icon={faArrowCircleLeft}
                  className="text-lg md:text-base"
                />
                <p className="ml-2 hidden md:block">Back To Course</p>
              </div>
            ) : (
              <div className="ml-10"></div>
            )}
          </Link>
        }
        {!is_activation ? (
          <div className="x-4 flex scale-90 items-center justify-center">
            <a href="/">
              <div
                className={`ml-1 flex w-fit items-center  gap-2 rounded-md bg-white p-2 md:ml-0 md:p-2`}
              >
                <img
                  src="https://img.learntube.ai/public-assets/post-payment-updates/image%2011.svg?updatedAt=1728356261811"
                  loading="eager"
                  alt=""
                  className="h-[31px] w-[31px] md:h-[35px] md:w-[35px]"
                />
                <p className="text-md font-medium text-black md:flex md:text-lg">
                  LearnTube.ai
                </p>
              </div>
            </a>
          </div>
        ) : (
          <div
            className={`ml-1 flex w-fit items-center  gap-2 rounded-md bg-white p-2 md:ml-0 md:p-2`}
          >
            <img
              src="https://img.learntube.ai/public-assets/post-payment-updates/image%2011.svg?updatedAt=1728356261811"
              loading="eager"
              alt=""
              className="h-[31px] w-[31px] md:h-[35px] md:w-[35px]"
            />
            <p className="text-md font-medium text-black md:flex md:text-lg">
              LearnTube.ai
            </p>
          </div>
        )}
        <div className="reactour-coinscertificates flex flex-row items-center justify-between md:flex-row">
          {/* <small className="reactour-progress w-10 h-10 font-bold hidden md:block mx-4">
            
          </small> */}
          <div
            className="mt-2 mr-5 flex h-10 cursor-pointer flex-col items-center justify-center md:h-12"
            onClick={() => {
              navigate("/pricing?type=coin");
            }}
          >
            <img
              urlEndpoint="https://img.learntube.ai/public-assets/"
              src={
                "https://img.learntube.ai/public-assets/Content_player/coinImage.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1676614260936"
              }
              className=" md: h-6 w-6"
              transformation={[
                {
                  height: "60",
                  width: "60",
                },
              ]}
            />
            <div className="mt-2 text-xs font-bold text-black ">
              {user_coin}
            </div>
          </div>
          <div>
            <button
              className=" group relative flex h-10 w-10 flex-col items-center  justify-center  font-semibold text-white md:h-10 md:w-10"
              onClick={() => {
                // setOpenConfirmationModal(true);
                // setType(
                //   challengeInfo?.['3day_challenge'] === 'completed'
                //     ? userActivity?.DOWNLOAD_FREE_CERTIFICATE.type
                //     : userActivity?.DOWNLOAD_PAID_CERTIFICATE.type
                // );
                // Mixpanel.track(Constants.Mixpanel.CERTIFICATE_DOWNLOAD_CLICK, {
                //   distinct_id: email,
                // });
                setIsPreview(true);
                console.log("clicking");
              }}
            >
              <CircularProgressbarWithChildren
                value={progress}
                strokeWidth={9}
                styles={buildStyles({
                  pathTransitionDuration: 0.5,
                  // Colors
                  pathColor: `#68DF5B`,
                  textColor: "#000",
                  trailColor: "rgb(163 163 163)",
                })}
              >
                {/* <FontAwesomeIcon icon={faCertificate} /> */}
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src={
                    "https://img.learntube.ai/public-assets/Content_player/certificate_image.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672151241471"
                  }
                  className=" h-5 w-5 md:h-5 md:w-5"
                  transformation={[
                    {
                      height: "60",
                      width: "60",
                    },
                  ]}
                />
              </CircularProgressbarWithChildren>
              {/* {progress !== 100 && (
                <div className="invisible group-hover:visible text-slate-500 text-xs absolute top-12 w-60 ">
                  Complete Quiz to
                  <br /> Unlock Certificate
                </div>
              )} */}
            </button>
            <p className="text-xs font-bold text-black">
              {user_name ? user_name?.split(" ")?.[0] : "User"}
            </p>
          </div>
        </div>
      </div>
      {isPreview && (
        <CertificatePreview
          isModalEnabled={isPreview}
          setIsModalEnabled={setIsPreview}
          mskillProgressObject={mskillProgressObject}
          skillProgress={skillProgress}
        />
      )}
      {is_activation && (
        <ExitPopUp
          isModalEnabled={isExitPopUp}
          setIsModalEnabled={setIsExitPopUp}
          quizRef={quizRef}
        />
      )}
    </>
  );
}
